import { useRequest } from "../../../hooks/useRequest";
import { useCallback, useEffect } from "react";
import routes from "../../../routes";

function useRiskIncidentsDetails(solutionId: string) {
  const { fetch, response, error, loading } = useRequest();

  const fetchSolutionRiskIncidents = useCallback(
    () => fetch("GET", routes.api.incidents.base({ solutionId })),

    [fetch, solutionId],
  );
  useEffect(() => {
    fetchSolutionRiskIncidents();
  }, [solutionId, fetchSolutionRiskIncidents]);
  return {
    details: response?.data,
    error,
    loading,
  };
}

export default useRiskIncidentsDetails;
